export default __webpack_public_path__ + "static/media/forward-10.3ae70e79.svg";